import "./ProjectStyles.css";
import React from 'react';

import Coding from '../assets/Coding.png';
import OOSE from '../assets/OOSE.png';
import VES from '../assets/VES.png';
import Python from '../assets/python.png'
import Android from '../assets/android.png'
import web from '../assets/web.png'
import iOS from '../assets/ios.png'
import Cloud from '../assets/cloud.png'
import oops from '../assets/oops.png'
import R from '../assets/r.png'
import swift from '../assets/swift.png'
import ml from '../assets/ml.png'
import cdk from '../assets/cdk.png'
import aws from '../assets/aws.png'
import devops from '../assets/devops.png'

import {Link} from 'react-router-dom';
import {BiLinkExternal} from "react-icons/bi";

const CertificateDemo = () => {
  return (
    <div>
      <section className="portfolio" id="portfolio">
        <h2 className="heading">My<span> Certificates</span></h2>
        <div className="portfolio-container" style={{zIndex:20}}>
            <div className="portfolio-box">
                <img src={cdk} alt="cdk"/>
                <div className="portfolio-layer">
                    <h4>Certificate of Achievement - CDK Global</h4>
                    <div className="connects">
                        <Link to="https://drive.google.com/file/d/1OC9MPZDh4xCurYs8MCA8nh6X_4vErpTN/view?usp=sharing" target="_blank"><BiLinkExternal size={30} style={{color:"var(--bg-color"}}/></Link>
                     </div>        
                </div>
            </div>
            <div className="portfolio-box">
                <img src={aws} alt="AWS"/>
                <div className="portfolio-layer">
                    <h4>AWS Cloud Practitioner Essentials - AWS Academy</h4>
                    <div className="connects">
                        <Link to="https://drive.google.com/file/d/1LD71_XvjmbRJOPTWfifZP4Gfct5WCfxE/view?usp=sharing" target="_blank"><BiLinkExternal size={30} style={{color:"var(--bg-color"}}/></Link>
                    </div>
                </div>
            </div>
            <div className="portfolio-box">
                <img src={devops} alt="Devops"/>
                <div className="portfolio-layer">
                    <h4>Introduction to Devops - Coursera</h4>
                    <div className="connects">
                        <Link to="https://www.coursera.org/account/accomplishments/verify/RCSUAPML4VSG" target="_blank"><BiLinkExternal size={30} style={{color:"var(--bg-color"}}/></Link>
                    </div>
                </div>
            </div>
        </div>
        <div className="portfolio-container" style={{zIndex:20}}>
            <div className="portfolio-box">
                <img src={iOS} alt="ios"/>
                <div className="portfolio-layer">
                    <h4>App Design And Development in iOS - Coursera</h4>
                    <div className="connects">
                        <Link to="https://coursera.org/share/ca5f3ef1072420c14b143eab3d8d3f6f" target="_blank"><BiLinkExternal size={30} style={{color:"var(--bg-color"}}/></Link>
                     </div>        
                </div>
            </div>
            <div className="portfolio-box">
                <img src={OOSE} alt="OOSE"/>
                <div className="portfolio-layer">
                    <h4>Software Engineering - Coursera</h4>
                    <div className="connects">
                        <Link to="https://coursera.org/share/d413f98d6f7ce43c5a1f0e7cd8cf8b4e" target="_blank"><BiLinkExternal size={30} style={{color:"var(--bg-color"}}/></Link>
                    </div>
                </div>
            </div>
            <div className="portfolio-box">
                <img src={Cloud} alt="Cloud"/>
                <div className="portfolio-layer">
                    <h4>Cloud Computing - Coursera</h4>
                    <div className="connects">
                        <Link to="https://coursera.org/share/3caa72a4458e4af36c7be73318cb80cb" target="_blank"><BiLinkExternal size={30} style={{color:"var(--bg-color"}}/></Link>
                    </div>
                </div>
            </div>
        </div>
        <div className="portfolio-container" style={{zIndex:20}}> 
            <div className="portfolio-box">
                <img src={Android} alt="Android"/>
                <div className="portfolio-layer">
                    <h4>Android App Components - Coursera</h4>
                    <div className="connects">
                        <Link to="https://coursera.org/share/9284462bcf5b539099e4855cbfa3f8d8" target="_blank"><BiLinkExternal size={30} style={{color:"var(--bg-color"}}/></Link>
                    </div>
                </div>
            </div>
            <div className="portfolio-box">
                <img src={VES} alt="VES"/>
                <div className="portfolio-layer">
                    <h4>Dynamic Public Speaking - Coursera</h4>
                    <div className="connects">
                        <Link to="https://coursera.org/share/31283effa521c1f01c5e58aaf480da49" target="_blank"><BiLinkExternal size={30} style={{color:"var(--bg-color"}}/></Link>
                    </div>
                </div>
            </div>
            <div className="portfolio-box">
                <img src={Coding} alt="Coding"/>
                <div className="portfolio-layer">
                    <h4>Coding Interview Preparation - Coursera</h4>
                   <div className="connects">
                        <Link to="https://coursera.org/share/0910c7ff16417b081fed9dfd333b038d" target="_blank"><BiLinkExternal size={30} style={{color:"var(--bg-color"}}/></Link>
                    </div>
                    
                </div>
            </div>
        </div>
        <div className="portfolio-container" style={{zIndex:20}}>
            <div className="portfolio-box">
                <img src={Python} alt="Python"/>
                <div className="portfolio-layer">
                    <h4>Certificate of Excellence in Python - Coding Ninjas</h4>
                    <div className="connects">
                        <Link to="https://certificate.codingninjas.com/view/95f242da52e03578" target="_blank"><BiLinkExternal size={30} style={{color:"var(--bg-color"}}/></Link>
                    </div>
                    
                </div>
            </div>
            <div className="portfolio-box">
                <img src={web} alt="web"/>
                <div className="portfolio-layer">
                    <h4>Web Development - Coding Ninjas</h4>
                    <div className="connects">
                        <Link to="https://certificate.codingninjas.com/verify/6683d07aa516dd08" target="_blank"><BiLinkExternal size={30} style={{color:"var(--bg-color"}}/></Link>
                         </div>
                </div>
            </div>
            <div className="portfolio-box">
                <img src={oops} alt="oops"/>
                <div className="portfolio-layer">
                    <h4>Certificate of Excellence in OOPS - Coding Ninjas</h4>
                    <div className="connects">
                        <Link to="https://certificate.codingninjas.com/verify/7ec24c6991c80702" target="_blank"><BiLinkExternal size={30} style={{color:"var(--bg-color"}}/></Link>
                    </div>
                </div>
            </div>
        </div>
        <div className="portfolio-container" style={{zIndex:20}}>
            <div className="portfolio-box">
                <img src={R} alt="R"/>
                <div className="portfolio-layer">
                    <h4>Introduction to R - Infosys SpringBoard</h4>
                    <div className="connects">
                        <Link to="https://infyspringboard.onwingspan.com/web/en/cert/2899d04c-ceac-4804-ad69-970d846a1dcf" target="_blank"><BiLinkExternal size={30} style={{color:"var(--bg-color"}}/></Link>
                    </div>
                    
                </div>
            </div>
            <div className="portfolio-box">
                <img src={swift} alt="swift"/>
                <div className="portfolio-layer">
                    <h4>Swift 4 with iOS-12 Training - Infosys SpringBoard</h4>
                    <div className="connects">
                        <Link to="https://drive.google.com/file/d/1l1s8nTBSu_6vLxUhbACwLmSWLHgRIHMR/view?usp=sharing" target="_blank"><BiLinkExternal size={30} style={{color:"var(--bg-color"}}/></Link>
                         </div>
                </div>
            </div>
            <div className="portfolio-box">
                <img src={ml} alt="ml"/>
                <div className="portfolio-layer">
                    <h4>Explore Machine Learning Using Python - Infosys SpringBoard</h4>
                    <div className="connects">
                        <Link to="https://infyspringboard.onwingspan.com/web/en/cert/bf70e1c5-bd89-4758-93f0-2f8b83825f97" target="_blank"><BiLinkExternal size={30} style={{color:"var(--bg-color"}}/></Link>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </div>
  )
}

export default CertificateDemo
